import type { RouteObject } from 'react-router-dom';
import Timer from '../pages/timer/page';
import PresetTimer from '../pages/timer/[minutes]/page';
import Stopwatch from '../pages/stopwatch/page';
import WorldClock from '../pages/worldclock/page';
import Timestamp from '../pages/timestamp/page';
import DiscordTimestamp from '../pages/discord-timestamp/page';
import YouTubeTimestampLink from '../pages/youtube-timestamp-link/page';
import MySQLTimestamp from '../pages/mysql-timestamp/page';
import CityTime from '../pages/worldclock/[city]/page';
import CountryTime from '../pages/worldclock/country/[countryCode]/page';
import NotFound from '../pages/NotFound';
import Terms from '../pages/terms/page';
import BeijingTime from '../pages/beijing-time';
import TestRoute from '../pages/test-route';
import PythonTimestamp from '../pages/python-timestamp/page';
import JavaScriptTimestamp from '../pages/javascript-timestamp/page';
import JavaTimestamp from '../pages/java-timestamp/page';
import PHPTimestamp from '../pages/php-timestamp/page';
import SQLTimestamp from '../pages/sql-timestamp/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Timer />,
  },
  {
    path: '/timer',
    element: <Timer />,
  },
  {
    path: '/timer/:minutes',
    element: <PresetTimer />,
  },
  {
    path: '/stopwatch',
    element: <Stopwatch />,
  },
  {
    path: '/worldclock',
    element: <WorldClock />,
  },
  {
    path: '/timestamp',
    element: <Timestamp />,
  },
  {
    path: '/timestamp-converter',
    element: <Timestamp />,
  },
  {
    path: '/discord-timestamp-generator',
    element: <DiscordTimestamp />,
  },
  {
    path: '/youtube-timestamp-link',
    element: <YouTubeTimestampLink />,
  },
  {
    path: '/mysql-timestamp',
    element: <MySQLTimestamp />,
  },
  {
    path: '/sql-timestamp',
    element: <SQLTimestamp />,
  },
  {
    path: '/postgresql-timestamp',
    element: <SQLTimestamp />,
  },
  {
    path: '/oracle-timestamp',
    element: <SQLTimestamp />,
  },
  {
    path: '/sqlserver-timestamp',
    element: <SQLTimestamp />,
  },
  {
    path: '/python-timestamp',
    element: <PythonTimestamp />,
  },
  {
    path: '/javascript-timestamp',
    element: <JavaScriptTimestamp />,
  },
  {
    path: '/java-timestamp',
    element: <JavaTimestamp />,
  },
  {
    path: '/php-timestamp',
    element: <PHPTimestamp />,
  },
  {
    path: '/worldclock/country/:countryName',
    element: <CountryTime />,
  },
  {
    path: '/worldclock/:citySlug',
    element: <CityTime />,
  },
  // 测试路由
  {
    path: '/test/:city',
    element: <TestRoute />,
  },
  {
    path: '/beijing-time',
    element: <BeijingTime />,
  },
  {
    path: '/terms',
    element: <Terms />
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
